import React, { useEffect, useState } from "react";
import { Button, Stepper } from "@mantine/core";
import { handleChangeUpload } from "../BulkAgreement/utils";
import { addDays, parseISO, subDays } from "date-fns";
import flat from "flat";
import { Progress } from "@mantine/core";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../redux/selectors";
import {
  createAgreement,
  putLegacyFlowJson,
} from "../../../utilities/apis/agreements";
import { apiWrapWithErrorWithData } from "../../../utilities/apiHelpers";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { attachFileToParent } from "../../../utilities/apis/commonApis";

const CreateBulkLegacyAgreement = () => {
  const [value, setValue] = useState(0);
  const currentUser = useSelector(selectUserData);
  const navigate = useNavigate();
  let columns = [
    "typeOfAgreement",
    "relationshipType",
    "relationshipWith",
    "titleOfAgreement",
    "requestingUserName",
    "requestingUserEmail",
    "requestingUserPhone",
    "requestingUserDesignation",
    "requestingUserDepartment",
    "dateOfContract",
    "noOfYears",
    "noOfMonths",
    "reminderTimeInDays",
    "location",
    "firstPartyType",
    "firstPartyEntityType",
    "firstPartyName",
    "secondPartyType",
    "secondPartyEntityType",
    "secondPartyName",
    "fileName",
    "folderId",
  ];

  const [flowJsonData, setFlowJsonData] = useState({});
  useEffect(() => {
    if (currentUser.loginAs.id === 3) {
      setFlowJsonData({
        3: [{ userId: currentUser.id, isLegacy: true, isComplete: true }],
        4: [],
        5: [],
        6: [],
        7: [],
      });
    } else if (currentUser.loginAs.id === 4) {
      setFlowJsonData({
        3: [],
        4: [{ userId: currentUser.id, isLegacy: true, isComplete: true }],
        5: [],
        6: [],
        7: [],
      });
    }
  }, []);

  const handleDownload = () => {
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += columns.join(",") + "\r\n";

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "bulklegacyagreements.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  let x = 0;

  useEffect(() => {
    if (value === 100) {
      navigate("/app/agreements_manager/docs-locker");
    }
  }, [value]);

  const handleFileChange = async (e) => {
    try {
      const file = e.target.files[0];
      const [csvData, formData] = await handleChangeUpload(file);

      for (let index = 0; index < csvData.length; index++) {
        let month, year, day;
        [day, month, year] = csvData[index].dateOfContract.split("/");
        const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
          2,
          "0",
        )}T00:00:00.000Z`;
        const contractMonths = csvData[index].noOfMonths
          ? parseInt(csvData[index].noOfMonths, 10) * 30
          : null;
        const contractYears = csvData[index].noOfYears
          ? parseInt(csvData[index].noOfYears, 10) * 365
          : null;
        const totalDays = contractMonths + contractYears;

        const contractDueDate = addDays(parseISO(formattedDate), totalDays);

        const formValues = {
          typeOfAgreement: csvData[index].typeOfAgreement,
          titleOfAgreement: csvData[index].titleOfAgreement,
          requestingUserDetails: {
            name: csvData[index].requestingUserName,
            email: csvData[index].requestingUserEmail,
          },
          dateOfContract: formattedDate,
          contractTermInDays: totalDays,
          noOfYears: parseInt(csvData[index].noOfYears, 10),
          noOfMonths: parseInt(csvData[index].noOfMonths, 10),
          location: csvData[index].location,
          reminderTimeInDays: parseInt(csvData[index].reminderTimeInDays, 10),
          dueDateOfContract: contractDueDate,
          completionDate: formattedDate,
          reminderTime: subDays(
            contractDueDate,
            csvData[index].reminderTimeInDays,
          ),
          contractQuillJsDelta: csvData[index].contractQuillJsDelta,
          firstParty: {
            name: csvData[index].firstPartyName,
            type: csvData[index].firstPartyType,
            entityType: csvData[index].firstPartyEntityType,
          },
          secondParty: {
            name: csvData[index].secondPartyName,
            type: csvData[index].secondPartyType,
            entityType: csvData[index].secondPartyEntityType,
          },
          thirdParty: {},
          fourthParty: {},
          fifthParty: {},
          formCompleted: true,
          relationshipType: csvData[index].relationshipType,
          relationshipWith: csvData[index].relationshipWith,
          businessUnit: currentUser.mapBusinessunit,
          status: "SIGNED",
        };
        const agreementData = {
          json: flat.unflatten({ ...formValues, isLegacy: true }),
          flatted: { ...formValues, isLegacy: true },
        };

        x = (index + 1) / csvData.length;
        const respo = await apiWrapWithErrorWithData(
          createAgreement({ agreementData, ...formValues }),
        );
        await apiWrapWithErrorWithData(
          putLegacyFlowJson(respo.agreement.id, flowJsonData),
        );

        const folder_id = csvData[index].folderId;
        const fileName = csvData[index].fileName;
        const api_key = "AIzaSyAGAoaxM9RohZro1Yxk2Qd77gaJU4evcnU";
        const response = await axios.get(
          `https://www.googleapis.com/drive/v3/files?q='${encodeURIComponent(
            folder_id,
          )}'+in+parents&key=${api_key}`,
        );
        const files = response.data.files;
        const file = files.find((obj) => obj.name === fileName);
        if (file) {
          const filetoAttach = {
            parent: "agreement",
            parentId: respo.agreement.id + "",
            fileName: fileName,
            hostedLink: `https://drive.google.com/file/d/${file.id}/view?key=${api_key}`,
            mimeType: file.mimeType,
            extension: fileName.split(".")[1],
          };

          await apiWrapWithErrorWithData(
            attachFileToParent({
              ...filetoAttach,
            }),
          );
        }
        setValue(x * 100);
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-4">
        <h1 className="text-center text-3xl font-bold text-gray-800 mb-4">
          create bulk legacy agreements
        </h1>
        <h3 className="text-lg text-gray-600 mb-2">
          download CSV file by clicking on download CSV button.
        </h3>
        <Button
          className="text-white   hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 transform hover:-translate-y-0.5 transition-all duration-300"
          onClick={handleDownload}
          style={{ backgroundColor: "#46BDE1" }}
        >
          download CSV
        </Button>
        <h3 className="text-lg text-gray-600 mt-4 mb-2">
          fill all the required fields and upload the CSV file.
        </h3>
        <div
          className="flex items-center mt-2 rounded"
          style={{ backgroundColor: "#46BDE1" }}
        >
          <input
            type="file"
            id="file"
            className="hidden"
            onChange={(e) => handleFileChange(e)}
          />
          <label
            htmlFor="file"
            className="text-white hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 cursor-pointer"
          >
            upload file
          </label>
        </div>
      </div>
      <Progress
        className="mt-20 mx-auto"
        style={{ width: "70%" }}
        radius="lg"
        size="lg"
        value={value}
        striped
        animated
      />
    </>
  );
};

export default CreateBulkLegacyAgreement;
